import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { goalActions } from 'store';
import { FindLoad, formatSecondDuration, formatSeconds, goalDataTypeEnums } from 'utils';
import { DateRow, FullTable, Loader, LocalDateRow, NoItemsYet } from 'components';
import { dataCollectionSessionNotYet, renderTrialAverageRow, trialDataBodyBody, trialDataHead } from './constants';
import moment from 'moment/moment';

const ACTION_TYPE = 'GET_GOAL_TRIAL_DATA';
export const TrialData = ({ session, target, single }) => {
    const goalById = useSelector((state) => state.goals.goalById);
    const goalTrialData = useSelector((state) => state.goals.goalTrialData);
    const dispatch = useDispatch();
    const loader = FindLoad(ACTION_TYPE);

    useEffect(() => {
        if (goalById?.id && session?.id) {
            dispatch(goalActions.getGoalTrialData(goalById?.id, session?.id));
        }
    }, [dispatch]);

    const renderTrialInformation = (trial) => {
        const totalTime = trial?.reduce((acc, trial) => {
            if (!trial?.startTime || !trial?.endTime) return acc;
            const startMoment = moment(trial.startTime);
            const endMoment = moment(trial.endTime);
            const differenceInSeconds = endMoment.diff(startMoment, 'seconds');
            return acc + differenceInSeconds;
        }, 0);
        const totalCount = trial?.reduce((acc, trial) => {
            if (!trial?.value) return acc;
            return acc + trial?.value;
        }, 0);

        return { totalTime, totalCount };
    };
    return (
        <div style={{ width: 1200, maxWidth: '100%' }}>
            {loader?.length ? (
                <Loader />
            ) : (
                <>
                    {single ? (
                        <div>
                            <p style={{ marginTop: '-12px' }} className="modal-header-title">
                                Session Date:
                                <DateRow date={target?.sessionDate} />
                            </p>
                            <FullTable
                                head={trialDataHead(target?.dataType)}
                                body={trialDataBodyBody(target?.dataType)}
                                list={target?.trials}
                                notYet={dataCollectionSessionNotYet}
                                height={'auto'}
                                activeRowId={''}
                                margin={'24px 0 0 0'}
                            />
                        </div>
                    ) : (
                        <div>
                            <p style={{ marginTop: '-12px' }} className="modal-header-title">
                                Session Date:
                                <LocalDateRow date={session?.startDate} />
                            </p>
                            {goalTrialData?.targets?.length > 0 ? (
                                goalTrialData?.targets?.map((i, j) => {
                                    return (
                                        <div key={j} className="goal-data-target-table-box">
                                            <div className="space-between">
                                                <div className="flex-align-center" style={{ gap: 10 }}>
                                                    <p className="goal-data-target-table-title">{i?.name}</p>
                                                    {i?.tSummary?.trialData && goalTrialData?.dataType !== goalDataTypeEnums.RATE && (
                                                        <div>
                                                            {renderTrialAverageRow({
                                                                ...i,
                                                                ...i?.tSummary?.trialData,
                                                                dataType: goalTrialData?.dataType,
                                                            })}
                                                        </div>
                                                    )}
                                                </div>
                                                {goalTrialData?.dataType === goalDataTypeEnums.RATE && (
                                                    <div className="rate-totals-box">
                                                        <div style={{ color: '#175CD3', background: '#EFF8FF' }}>
                                                            <p>Total Freq:</p>
                                                            <span>{renderTrialInformation(i?.tSummary?.trials)?.totalCount}</span>
                                                        </div>
                                                        <div style={{ color: '#C4320A', background: '#FFF6ED' }}>
                                                            <p>Total Dur:</p>
                                                            <span>
                                                                {formatSeconds(renderTrialInformation(i?.tSummary?.trials)?.totalTime)}
                                                            </span>
                                                        </div>
                                                        <div style={{ color: '#027A48', background: '#ECFDF3' }}>
                                                            <p>Avg Rate:</p>
                                                            <span>{`${i?.tSummary?.trialData?.value}${i?.tSummary?.trialData?.info}`}</span>
                                                        </div>
                                                    </div>
                                                )}
                                            </div>
                                            {i?.tSummary?.trials?.length && (
                                                <FullTable
                                                    head={trialDataHead(goalTrialData?.dataType)}
                                                    body={trialDataBodyBody(goalTrialData?.dataType)}
                                                    list={i?.tSummary?.trials}
                                                    notYet={dataCollectionSessionNotYet}
                                                    height={'auto'}
                                                    activeRowId={''}
                                                    margin={'16px 0 0 0'}
                                                />
                                            )}
                                        </div>
                                    );
                                })
                            ) : (
                                <div style={{ height: dataCollectionSessionNotYet?.height }}>
                                    <NoItemsYet
                                        height={dataCollectionSessionNotYet?.height}
                                        text={'Session don’t have Targets yet'}
                                        subTitle={dataCollectionSessionNotYet.subTitle}
                                        image={dataCollectionSessionNotYet.image}
                                    />
                                </div>
                            )}
                        </div>
                    )}
                </>
            )}
        </div>
    );
};
